import {
    LIST_TRACKER_ACCOUNTS,
    STORE_TRACKER_ACCOUNTS,
    STORE_TRACKER_ACCOUNT,
    MARK_TRACKER_ACCOUNT_CANCELLED,
    REMOVE_TRACKER_ACCOUNT,
    SAVE_TRACKER_ACCOUNT,
    CANCEL_TRACKER_ACCOUNT,
    DELETE_TRACKER_ACCOUNT,
    SAVE_TRACKER_CELL,
} from '../../constants/businessTracker';

export const listTrackerAccounts = (data) => ({
    type: LIST_TRACKER_ACCOUNTS,
    data,
});

export const storeTrackerAccounts = (accounts) => ({
    type: STORE_TRACKER_ACCOUNTS,
    accounts,
});

export const storeTrackerAccount = (account) => ({
    type: STORE_TRACKER_ACCOUNT,
    account,
});

export const markTrackerAccountCancelled = (accountId) => ({
    type: MARK_TRACKER_ACCOUNT_CANCELLED,
    accountId,
});

export const removeTrackerAccount = (accountId) => ({
    type: REMOVE_TRACKER_ACCOUNT,
    accountId,
});

export const saveTrackerAccount = (data, callback) => ({
    type: SAVE_TRACKER_ACCOUNT,
    data,
    callback,
});

export const cancelTrackerAccount = (data, callback) => ({
    type: CANCEL_TRACKER_ACCOUNT,
    data,
    callback,
});

export const deleteTrackerAccount = (data, callback) => ({
    type: DELETE_TRACKER_ACCOUNT,
    data,
    callback,
});

export const saveTrackerCell = (data, callback) => ({
    type: SAVE_TRACKER_CELL,
    data,
    callback,
});
